import React, { Dispatch, SetStateAction } from 'react';
import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import { Button, makeStyles } from '@fluentui/react-components';
import { OpenRegular } from '@fluentui/react-icons';
import { MilestoneRuleType, IMilestoneRule } from './Interfaces';
import DocumentGate from './milestoneRules/DocumentGate';
import DividendGate from './milestoneRules/DividendGate';
import AuditOpinionGate from './milestoneRules/AuditOpinionGate';
import CelaAgmStatusGate from './milestoneRules/CelaAgmStatusGate';
import ReasonForViolationGate from './milestoneRules/ReasonForViolationGate';
import { iconClass, paddedIconClass } from './milestoneRules/Gate.Styles';
import AgmDetailGate from './milestoneRules/AgmDetailGate';

interface IMilestoneRuleChecklistProps {
  milestoneRules: IMilestoneRule[];
  disabled: boolean;
  milestoneId: number;
  milestoneTitle: string;
  isMilestoneComplete: boolean;
  toggleDividendsPanel: () => void;
  commentsVisible: boolean;
  setCommentsVisible: Dispatch<SetStateAction<boolean>>;
}

const useStyles = makeStyles({
  ruleChecklist: { width: '260px' },
});

const MilestoneRuleChecklist = ({
  milestoneRules,
  milestoneId,
  milestoneTitle,
  disabled,
  isMilestoneComplete,
  toggleDividendsPanel,
  commentsVisible,
  setCommentsVisible,
}: IMilestoneRuleChecklistProps): JSX.Element => {
  const classes = useStyles();
  const toggleMilestoneDrilldownInfo = (): void => {
    if (commentsVisible) {
      setCommentsVisible(false);
    } else {
      setCommentsVisible(true);
    }
  };
  return (
    <Stack className={classes.ruleChecklist} horizontalAlign="start">
      {milestoneRules.map((rule) => {
        switch (rule.type) {
          case MilestoneRuleType.reasonForViolation:
            return (
              <ReasonForViolationGate
                key={rule.id}
                rule={rule}
                milestoneId={milestoneId}
                isMilestoneComplete={isMilestoneComplete}
                disabled={disabled}
              />
            );
          case MilestoneRuleType.documentUpload:
            return (
              <DocumentGate
                key={rule.id}
                rule={rule}
                milestoneId={milestoneId}
                milestoneTitle={milestoneTitle}
                isMilestoneComplete={isMilestoneComplete}
                disabled={disabled}
              />
            );
          case MilestoneRuleType.dividendGate:
            return (
              <DividendGate
                key={rule.id}
                rule={rule}
                milestoneId={milestoneId}
                disabled={disabled}
                toggleDividendsPanel={toggleDividendsPanel}
              />
            );
          case MilestoneRuleType.auditOpinion:
            return (
              <AuditOpinionGate
                key={rule.id}
                rule={rule}
                milestoneId={milestoneId}
                disabled={disabled}
              />
            );
          case MilestoneRuleType.celaAgmStatus:
            return (
              <CelaAgmStatusGate
                key={rule.id}
                rule={rule}
                milestoneId={milestoneId}
                disabled={disabled}
              />
            );
          case MilestoneRuleType.agmDetail:
            return <AgmDetailGate key={rule.id} rule={rule} />;
          default:
            return <span key={rule.type}>{rule.type}</span>;
        }
      })}
      <Button
        style={{ textAlign: 'start' }}
        appearance="transparent"
        aria-label={`Milestone details and comments — ${milestoneTitle}`}
        onClick={toggleMilestoneDrilldownInfo}
      >
        <OpenRegular className={`${iconClass} ${paddedIconClass}`} />
        Milestone details and comments
      </Button>
    </Stack>
  );
};

export default MilestoneRuleChecklist;
